
[
  {
    "id": "TG-B6-L101-001",
    "module": "TijdGeld",
    "difficulty": 101,
    "question": "Hoeveel minuten zitten er in een uur?",
    "options": ["60 minuten", "100 minuten", "30 minuten", "12 minuten"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "klokkijken",
    "subSkill": "klokkijken_basis",
    "familyId": "TG-UUR-MIN",
    "explanation": "Een uur heeft 60 minuten.",
    "distractorExplanations": {
      "1": "Dat is bij geld (100 cent).",
      "2": "Dat is een half uur.",
      "3": "Dat is op de klok (12 uur)."
    }
  },
  {
    "id": "TG-B6-L101-002",
    "module": "TijdGeld",
    "difficulty": 101,
    "question": "Hoeveel cent is 1 euro?",
    "options": ["100 cent", "10 cent", "1000 cent", "50 cent"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "geld_tellen",
    "subSkill": "geld_munten",
    "familyId": "TG-EURO-CENT",
    "explanation": "1 euro is 100 cent.",
    "distractorExplanations": {
      "1": "Dat is een dubbeltje.",
      "2": "Dat is 10 euro.",
      "3": "Dat is een halve euro."
    }
  },
  {
    "id": "TG-B6-L101-003",
    "module": "TijdGeld",
    "difficulty": 101,
    "question": "Het is kwart over 3. Hoe laat is het 15 minuten later?",
    "options": ["Half 4", "3 uur", "Kwart voor 4", "4 uur"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tijdrekenen",
    "subSkill": "tijdsduur_berekenen",
    "familyId": "TG-KWARTIER-LATER",
    "explanation": "Kwart over 3 + 15 minuten = half 4.",
    "distractorExplanations": {
      "1": "Dat is eerder.",
      "2": "Dat is een half uur later.",
      "3": "Dat is drie kwartier later."
    }
  },
  {
    "id": "TG-B6-L101-004",
    "module": "TijdGeld",
    "difficulty": 101,
    "question": "Je koopt een ijsje van € 1,50. Je betaalt met € 2,00. Hoeveel krijg je terug?",
    "options": ["50 cent", "1 euro", "20 cent", "Niets"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "geld_tellen",
    "subSkill": "geld_wisselgeld",
    "familyId": "TG-IJSJE",
    "explanation": "2,00 - 1,50 = 0,50. Dat is 50 cent.",
    "distractorExplanations": {
      "1": "Dat is te veel.",
      "2": "Dat is te weinig.",
      "3": "Je krijgt wel wisselgeld."
    }
  },
  {
    "id": "TG-B6-L101-005",
    "module": "TijdGeld",
    "difficulty": 101,
    "question": "Hoeveel dagen heeft een week?",
    "options": ["7 dagen", "5 dagen", "10 dagen", "12 dagen"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "kalender",
    "subSkill": "kalender_basis",
    "familyId": "TG-WEEK",
    "explanation": "Maandag t/m zondag zijn 7 dagen.",
    "distractorExplanations": {
      "1": "Dat is een werkweek.",
      "2": "Dat is te veel.",
      "3": "Dat zijn maanden in een jaar."
    }
  },
  {
    "id": "TG-B6-L101-006",
    "module": "TijdGeld",
    "difficulty": 101,
    "question": "Hoeveel uur heeft een dag?",
    "options": ["24 uur", "12 uur", "48 uur", "60 uur"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "klokkijken",
    "subSkill": "klokkijken_basis",
    "familyId": "TG-DAG-UUR",
    "explanation": "Een dag heeft 24 uur: 12 uur overdag en 12 uur 's nachts.",
    "distractorExplanations": {
      "1": "Dat is een halve dag (de klok gaat tot 12).",
      "2": "Dat zijn 2 dagen.",
      "3": "60 is het aantal minuten in een uur."
    }
  },
  {
    "id": "TG-B6-L101-007",
    "module": "TijdGeld",
    "difficulty": 101,
    "question": "Hoeveel is een half uur in minuten?",
    "options": ["30 minuten", "15 minuten", "45 minuten", "60 minuten"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "klokkijken",
    "subSkill": "klokkijken_basis",
    "familyId": "TG-HALFUUR",
    "explanation": "Een uur is 60 minuten. De helft is 30 minuten.",
    "distractorExplanations": {
      "1": "Dat is een kwartier.",
      "2": "Dat is driekwart uur.",
      "3": "Dat is een heel uur."
    }
  },
  {
    "id": "TG-B6-L101-008",
    "module": "TijdGeld",
    "difficulty": 101,
    "question": "Je koopt een broodje van € 2,75. Je betaalt met € 5,00. Hoeveel krijg je terug?",
    "options": ["€ 2,25", "€ 2,75", "€ 3,25", "€ 1,25"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "geld_tellen",
    "subSkill": "geld_wisselgeld",
    "familyId": "TG-BROODJE",
    "explanation": "5,00 - 2,75 = 2,25. Je krijgt € 2,25 terug.",
    "distractorExplanations": {
      "1": "Dat is de prijs van het broodje zelf.",
      "2": "Rekenfoutje: 5,00 - 2,75 = 2,25.",
      "3": "Te weinig terug."
    }
  },
  {
    "id": "TG-B6-L101-009",
    "module": "TijdGeld",
    "difficulty": 101,
    "question": "Hoeveel maanden heeft een jaar?",
    "options": ["12 maanden", "10 maanden", "24 maanden", "52 maanden"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "kalender",
    "subSkill": "kalender_basis",
    "familyId": "TG-JAAR-MAAND",
    "explanation": "Een jaar heeft 12 maanden: januari t/m december.",
    "distractorExplanations": {
      "1": "Dat zijn te weinig maanden.",
      "2": "Dat zijn 2 jaar.",
      "3": "52 is het aantal weken in een jaar."
    }
  },
  {
    "id": "TG-B6-L101-010",
    "module": "TijdGeld",
    "difficulty": 101,
    "question": "Hoeveel cent is € 0,50?",
    "options": ["50 cent", "5 cent", "500 cent", "15 cent"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "geld_tellen",
    "subSkill": "geld_munten",
    "familyId": "TG-HALVE-EURO",
    "explanation": "€ 0,50 is 50 cent. Dat is een halve euro.",
    "distractorExplanations": {
      "1": "Dat is € 0,05.",
      "2": "Dat is € 5,00.",
      "3": "Dat is € 0,15."
    }
  },
  {
    "id": "TG-B6-L101-011",
    "module": "TijdGeld",
    "difficulty": 101,
    "question": "Het is 10 uur. Hoe laat is het over 2 uur?",
    "options": ["12 uur", "8 uur", "10 uur", "14 uur"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tijdrekenen",
    "subSkill": "tijdsduur_berekenen",
    "familyId": "TG-PLUS-2UUR",
    "explanation": "10 uur + 2 uur = 12 uur.",
    "distractorExplanations": {
      "1": "Je trok 2 uur af in plaats van erbij.",
      "2": "Je deed er niets bij.",
      "3": "14 uur is op de 24-uursklok, maar de vraag is in gewone tijd."
    }
  },
  {
    "id": "TG-B6-L101-012",
    "module": "TijdGeld",
    "difficulty": 101,
    "question": "Hoeveel is € 1,00 + € 0,50 + € 0,20?",
    "options": ["€ 1,70", "€ 1,50", "€ 1,20", "€ 2,00"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "geld_tellen",
    "subSkill": "geld_munten",
    "familyId": "TG-MUNTEN-OPTELLEN",
    "explanation": "1,00 + 0,50 = 1,50. Dan 1,50 + 0,20 = 1,70.",
    "distractorExplanations": {
      "1": "Je vergat de 20 cent.",
      "2": "Je vergat de 50 cent.",
      "3": "Je telde te veel."
    }
  },
  {
    "id": "TG-B6-L101-013",
    "module": "TijdGeld",
    "difficulty": 101,
    "question": "Welke maand komt na juni?",
    "options": ["Juli", "Mei", "Augustus", "Maart"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "kalender",
    "subSkill": "kalender_basis",
    "familyId": "TG-MAAND-NA",
    "explanation": "Na juni komt juli. De volgorde is: mei, juni, juli, augustus.",
    "distractorExplanations": {
      "1": "Mei komt vóór juni.",
      "2": "Augustus komt na juli.",
      "3": "Maart is veel eerder in het jaar."
    }
  },
  {
    "id": "TG-B6-L101-014",
    "module": "TijdGeld",
    "difficulty": 101,
    "question": "Het is kwart voor 5. Hoe laat is het op de digitale klok?",
    "options": ["4:45", "5:15", "5:45", "4:15"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "klokkijken",
    "subSkill": "klokkijken_digitaal",
    "familyId": "TG-KWART-VOOR",
    "explanation": "Kwart voor 5 is 15 minuten vóór 5 uur. Dat is 4:45.",
    "distractorExplanations": {
      "1": "Dat is kwart óver 5.",
      "2": "Dat is kwart voor 6.",
      "3": "Dat is kwart over 4."
    }
  },
  {
    "id": "TG-B6-L101-015",
    "module": "TijdGeld",
    "difficulty": 101,
    "question": "Je hebt € 3,00. Een appel kost € 0,80. Hoeveel appels kun je kopen?",
    "options": ["3 appels", "4 appels", "2 appels", "5 appels"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "geld_rekenen",
    "subSkill": "boodschappen",
    "familyId": "TG-APPELS-KOPEN",
    "explanation": "3 × € 0,80 = € 2,40. Dat past. 4 × € 0,80 = € 3,20. Dat is te veel. Dus 3 appels.",
    "distractorExplanations": {
      "1": "4 × 0,80 = 3,20. Dat is meer dan € 3,00.",
      "2": "Je hebt genoeg voor meer dan 2 appels.",
      "3": "5 × 0,80 = 4,00. Dat is veel te veel."
    }
  }
]
